module.exports = __webpack_public_path__ + "img/logo.c148119a.png";